module.exports = __webpack_public_path__ + "img/GIS_Racial_Discrimination.2bd1ea66.svg";